/**
 * Powerplugs — Theme Animations
 * Bestand: assets/pp-animations.js
 *
 * Inladen onderaan theme.liquid, vóór </body>:
 * <script src="{{ 'pp-animations.js' | asset_url }}" defer></script>
 *
 * Bevat:
 * 1. Scroll fade-in animaties
 * 2. Smooth page transitions
 * 3. Parallax op hero achtergrond
 */

(function () {
  'use strict';

  // ── Respect prefers-reduced-motion ──────────────────
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ════════════════════════════════════════════════════
  // 1. SCROLL FADE-IN
  // Voeg class "pp-reveal" toe aan elk element dat je
  // wilt laten infaden. Of gebruik de auto-selector
  // hieronder die automatisch secties, koppen en
  // kaarten oppakt.
  // ════════════════════════════════════════════════════
  function initScrollReveal() {
    if (reducedMotion) return;

    const style = document.createElement('style');
    style.textContent = `
      /* Kill all Dawn animations */
      .animate--hover-image,
      .animate--hover-zoom,
      [class*="animate--"],
      .motion-reduce,
      .scroll-trigger,
      .scroll-trigger.animate--slide-in,
      .scroll-trigger.animate--fade-in,
      .scroll-trigger.animate--zoom-in {
        animation: none !important;
        transition: none !important;
        opacity: 1 !important;
        transform: none !important;
        visibility: visible !important;
      }

      .pp-reveal {
        opacity: 0;
        transform: translateY(28px);
        transition: opacity 0.55s cubic-bezier(.22,.68,0,1.2),
                    transform 0.55s cubic-bezier(.22,.68,0,1.2);
      }
      .pp-reveal.pp-revealed {
        opacity: 1;
        transform: translateY(0);
      }
      .pp-reveal-delay-1 { transition-delay: 0.08s; }
      .pp-reveal-delay-2 { transition-delay: 0.16s; }
      .pp-reveal-delay-3 { transition-delay: 0.24s; }
      .pp-reveal-delay-4 { transition-delay: 0.32s; }
    `;
    document.head.appendChild(style);



    // Auto-selecteer elementen
    const autoSelectors = [
      '.pp-hero-left',
      '.pp-pg-h2', '.pp-pg-sub',
      '.pp-card',
      '.pp-cc-card',
      '.pp-faq-item',
      '.pp-cf-box',
      '.pp-ch-h1', '.pp-ch-sub', '.pp-ch-eyebrow',
      '.pp-t-lab',
      '[data-pp-reveal]',
    ];

    const elements = document.querySelectorAll(autoSelectors.join(','));

    elements.forEach(function (el) {
      el.classList.add('pp-reveal');
    });

    // Kaarten staggered delay
    document.querySelectorAll('.pp-pg-grid .pp-card, .pp-cc-grid .pp-cc-card').forEach(function (el, i) {
      el.classList.add('pp-reveal-delay-' + Math.min(i % 4 + 1, 4));
    });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pp-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.pp-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  // ════════════════════════════════════════════════════
  // 2. SMOOTH PAGE TRANSITIONS
  // Pagina fadet uit bij klik op interne link,
  // en fadet in bij laden.
  // ════════════════════════════════════════════════════
  function initPageTransitions() {
    if (reducedMotion) return;

    const style = document.createElement('style');
    style.textContent = `
      body {
        animation: pp-page-in 0.35s ease forwards;
      }
      @keyframes pp-page-in {
        from { opacity: 0; transform: translateY(8px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      body.pp-page-leaving {
        opacity: 0;
        transform: translateY(-6px);
        transition: opacity 0.2s ease, transform 0.2s ease;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);

    // Ruim de animatie op zodra hij klaar is. "forwards" houdt
    // anders een permanente (niet-"none") transform op <body>,
    // wat een nieuw containing block creëert voor position:fixed
    // elementen (bijv. de Shopify chat-widget) — die blijven dan
    // niet meer vastgeplakt aan het scherm maar scrollen mee.
    document.body.addEventListener('animationend', function handler(e) {
      if (e.animationName === 'pp-page-in') {
        document.body.style.animation = 'none';
        document.body.removeEventListener('animationend', handler);
      }
    });

    document.addEventListener('click', function (e) {
      const link = e.target.closest('a');
      if (!link) return;
      if (!link.href) return;

      const url = new URL(link.href);
      // Alleen interne links, geen anchors, geen nieuwe tabs
      if (
        url.origin !== window.location.origin ||
        link.target === '_blank' ||
        link.href.includes('#') ||
        e.metaKey || e.ctrlKey
      ) return;

      e.preventDefault();
      document.body.classList.add('pp-page-leaving');

      setTimeout(function () {
        window.location.href = link.href;
      }, 200);
    });
  }

  // ════════════════════════════════════════════════════
  // 3. PARALLAX OP HERO
  // Hero achtergrond scrollt 30% langzamer dan pagina.
  // ════════════════════════════════════════════════════
  function initParallax() {
    if (reducedMotion) return;
    if (window.matchMedia('(hover: none)').matches) return; // skip mobiel

    const hero = document.querySelector('.pp-hero');
    if (!hero) return;

    let ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          const scrollY = window.scrollY;
          const heroHeight = hero.offsetHeight;

          if (scrollY < heroHeight * 1.5) {
            const offset = scrollY * 0.3;
            hero.style.backgroundPositionY = 'calc(55% + ' + offset + 'px)';
          }

          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

//   // ════════════════════════════════════════════════════
//   // INIT — wacht tot DOM klaar is
//   // ════════════════════════════════════════════════════
//   function init() {
//     initScrollReveal();
//     initPageTransitions();
//     initParallax();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

// })();


// for page speed by ps

  // ════════════════════════════════════════════════════
  // INIT — run after initial page rendering
  // ════════════════════════════════════════════════════
  function init() {
    initScrollReveal();
    initPageTransitions();
    initParallax();
  }

  function scheduleInit() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(init, { timeout: 2000 });
    } else {
      setTimeout(init, 1);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
  } else {
    scheduleInit();
  }

})();
